<ng-container *ngIf="!isLoading; else loadingTemplate">

  <div [ngClass]="isMobile ? 'mobile-header' : 'header'">
    <app-external-header
      style="z-index: 1000; position: relative;"
      [isInboxPresent]="false"
      [isCompanyProfile]="false"
      [isProfile]="true"
      [showButtons]="false"
      [isMobile]="isMobile"
      [showProfilePicture]="true"
    ></app-external-header>
  </div>

  <div class="main-wrapper">
    <div class="back-button">
      <app-button
        (click)="goBack()"
        [label]="'auth.back' | translate"
        [size]="ButtonSize.LARGER"
        [state]="ButtonState.REGULAR"
        [type]="ButtonType.GHOST"
      ></app-button>
    </div>

    <div class="applications-table">
      <app-candidates-table [rows]="rows"></app-candidates-table>
    </div>
  </div>

  <div class="footer-class">
    <app-footer></app-footer>
  </div>
</ng-container>
<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
